<template>
    <div>
        <Content :style="{padding: '24px', minHeight: '480px', background: '#fff'}">
            <el-form ref="queryParams" inline label-position="right" label-width="80px" v-model="queryParams">
                <el-form-item label="快递单号">
                    <el-input size="small" @keyup.enter.native="search()" v-model="queryParams.expressNos" placeholder="你要退货的包裹订单" style="width: 160px" />
                </el-form-item>
                <el-form-item label="收件人">
                    <el-input size="small" @keyup.enter.native="search()" v-model="queryParams.name" placeholder="收件人" style="width: 120px" />
                </el-form-item>
                <el-form-item label="电话号码">
                    <el-input size="small" @keyup.enter.native="search()" v-model="queryParams.phone" placeholder="电话号码" style="width: 120px" />
                </el-form-item>
                <el-form-item label="退回单号">
                    <el-input size="small" @keyup.enter.native="search()" v-model="queryParams.backExpressNo" placeholder="货代寄回的退回单号" style="width: 160px" />
                </el-form-item>
                <el-form-item>
                    <el-button size="small" v-on:click="search()" type="primary">搜索</el-button>
                    <el-button size="small" v-on:click="reset()">重置</el-button>
                </el-form-item>
            </el-form>
            <el-row :style="{marginBottom:'20px'}">
                <font color="#f00">状态：</font>
                <el-button size="small"  :type="queryParams.state==null?'success':'default'" v-on:click="searchFilterDeadLine(null)">全部</el-button>
                <el-button size="small"  :type="queryParams.state==0?'success':'default'" v-on:click="searchFilterDeadLine(0)">待处理
                    <Badge :count="toCount"></Badge>
                </el-button>
                <el-button size="small"  :type="queryParams.state==1?'success':'default'" v-on:click="searchFilterDeadLine(1)">已寄件</el-button>
                <el-button size="small"  v-on:click="reset()" type="danger">重置</el-button>
            </el-row>
            <Table :loading="loading" :columns="columns" :data="expressBacks" border>
            </Table>
            <div style="margin: 10px;overflow: hidden">
                <div style="float: right;">
                    <Page :page-size="page.pageSize" show-total :total="page.total" :current="page.current" @on-change="changePage"></Page>
                </div>
            </div>
            <CExpressBackOk ref="addDialog" @ok="getList()" :backId="expressBack.id">
                </CExpressBackOk>
                <CExpressBack ref="backDialog" @ok="getList()" :backId="expressBack.id">
                </CExpressBack>
        </Content>
    </div>
</template>
<script>
import api from "@/api/api"
import CExpressBackOk from "./CExpressBackOk.vue"
import CExpressBack from "./CExpressBack.vue"

export default {
    name: 'ExpressBack',
    data() {
        return {
            loading: false,

            queryParams: {
                state: null,
            },
            others: {

            },
            expressBack: {

            },
            page: {
                total: 0,
                current: 1,
                pageSize: 10
            },
            expressBacks: [

            ],
            rules: {},
            columns: [{
                    title: '仓库',
                    key: 'warehouseName',
                    width: 130,
                    align: 'center'
                }, {
                    title: '退件快递单号',
                    key: 'expressNos',
                    width: 130,
                    align: 'center'
                }, {
                    title: '新增时间',
                    key: 'createTime',
                    width: 130,
                    align: 'center',
                    render: (h, params) => {
                        var me = this;
                        return h("div", [
                            h("span", { style: {} }, me.long2datetime(params.row.createTime))
                        ]);
                    }
                }, {
                    title: '收件人',
                    key: 'name',
                    width: 130,
                    align: 'center',
                    render: (h, params) => {
                        var me = this;
                        let row = params.row;
                        return h("div", [
                            h("div", { style: {} }, row.name + "，" + row.phone),
                            h("div", { style: {} }, row.address)
                        ]);
                    }
                }, {
                    title: '状态',
                    key: 'state',
                    width: 130,
                    align: 'center',
                    render: (h, params) => {
                        var me = this;
                        let row = params.row;
                        let txt = row.state == 0 ? "待处理" : row.state == 1 ? "已寄件" : "异常待处理";
                        let cls = row.state == 0 ? "state-info-full" : row.state == 1 ? "state-success-full" : "state-error-full";
                        return h("div", [
                            h("span", { class: cls, style: {} }, txt)

                        ]);
                    }

                }, {
                    title: '商家备注',
                    key: 'remark',
                    width: 130,
                    align: 'center'
                }, {
                    title: '处理备注',
                    key: 'sysRemark',
                    width: 130,
                    align: 'center'
                }, {
                    title: '退回单号',
                    key: 'backExpressNo',
                    width: 130,
                    align: 'center',
                    render: (h, params) => {
                        var me = this;
                        let row = params.row;
                        let btns = [

                        ];
                        if (row.state == 1) {
                            btns.push(h("a", {
                                attrs: {
                                    href: api.baiduUrl + row.backExpressNo,
                                    target: "_blank"
                                }
                            }, row.backExpressNo))
                        }
                        return h("div", {}, btns);
                    }
                }, {
                    title: '操作',
                    key: 'state',

                    align: 'center',
                    render: (h, params) => {
                        var row = params.row;
                        let btns = [

                        ];
                        if (row.state == -1) {
                            // btns.push(
                            //     h("Button", { style: { marginRight: "5px" }, props: { size: "small" }, on: { click: () => {
                            //         this.backError(row.id)
                            //     } } }, "异常撤回"));
                        }
                        if (row.state == 1) {
                            btns.push(
                                h("Button", {
                                    style: { marginRight: "5px" },
                                    props: { size: "small", type: "error" },
                                    on: {
                                        click: () => {
                                            this.backOk(row)
                                        }
                                    }
                                }, "撤回寄件"));
                        }
                        if (row.state == 0) {
                            btns.push(
                                h("Button", {
                                    style: { marginRight: "5px" },
                                    props: { size: "small", type: "error" },
                                    on: {
                                        click: () => {
                                            this.editError(row);
                                        }
                                    }
                                }, "设为异常件"));
                            btns.push(
                                h("Button", {
                                    style: { marginRight: "5px" },
                                    props: { size: "small", type: "success" },
                                    on: {
                                        click: () => {
                                            this.edit(row)
                                        }
                                    }
                                }, "确认寄件"));
                        }

                        return h("div", btns);
                    }
                }

            ]
        };
    },
    mounted: function() {
        this.getList();

    },
    components: {
        CExpressBackOk,
        CExpressBack
    },
    computed: {
        toCount: function() {

            return this.$store.state.notify.notifyCount.expressBackCount;

        }

    },
    methods: {
        searchFilterDeadLine: function(state) {
            this.queryParams.state = state;
            this.search();
        },
        cbtime: function(value) {
            this.others;
        },
        search: function() {
            this.page.current = 1;
            this.page.total = 0;
            this.getList();
        },
        reset: function() {
            this.queryParams = { state: null };
            this.search();
        },
        changePage(current) {
            this.page.current = current;
            this.getList();
        },
        getList: function() {
            var me = this;
            var params = me.queryParams;
            params.current = me.page.current;
            params.pageSize = me.page.pageSize;
            me.loading = true;
            me.$http.post("/ware/expressback/getList.action", params).then(response => {
                var body = response;
                if (body.status == 0) {
                    me.page.total = body.obj.totalCount;
                    me.expressBacks = body.obj.list;

                }
                me.loading = false;
            }, response => {
                me.loading = false;
            });
        },
        backError: function(id) {
            //
            var me = this;
            me.$Modal.confirm({
                title: "提示",
                content: "是否执行该操作",
                onOk: function() {
                    me.$http.post("/ware/expressback/doBack.action", { id: id }).then(response => {
                        var body = response;
                        if (body.status == 0) {
                            me.getList();

                        } else {
                            me.$Message.error("操作异常!" + body.info);
                        }
                    }).catch(error => {

                    });
                },
                onCancel: function() {

                }
            });
        },

        backOk: function(row) {
            //已寄件退款
            var me = this;
            me.$Modal.confirm({
                title: "提示",
                content: "是否执行撤回，运费将会返还给客户",
                onOk: function() {
                    me.showLoading();
                    me.$http.post("/ware/expressback/doOkBack.action", { id: row.id }).then(response => {
                        me.hideLoading();
                        var body = response;
                        if (body.status == 0) {
                            me.getList();

                        } else {
                            me.$Message.error("操作异常!" + body.info);
                        }
                    }).catch(error => {
                        me.$Message.error("操作异常!" + error);
                        me.hideLoading();
                    });
                },
                onCancel: function() {

                }
            });
        },
        edit: function(row) {
            //寄件
            this.expressBack = row;
            this.$refs['addDialog'].showDialog();
        },
        editError: function(row) {
            this.expressBack = row;
            this.$refs['backDialog'].showDialog();
        }

    }
}
</script>
<style scoped>
</style>